// extracted by mini-css-extract-plugin
module.exports = {"page-wrapper":"TemplatePricing_page-wrapper__RctSR","heading":"TemplatePricing_heading__nV4S0"};